module.exports = __webpack_public_path__ + "img/io-1.4857369c.jpg";